import { render } from "./OrderConfirmation.vue?vue&type=template&id=f516fe28&scoped=true"
import script from "./OrderConfirmation.vue?vue&type=script&lang=js"
export * from "./OrderConfirmation.vue?vue&type=script&lang=js"

import "./OrderConfirmation.vue?vue&type=style&index=0&id=f516fe28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f516fe28"]])

export default __exports__